<template>
  <v-main style="max-width: 1600px; margin: auto">
    <Transition name="scroll-y-reverse-transition" mode="out-in">
      <!--//@*/*
            //    *RPD  App v0.91
            //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
            //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
            //    */
            //-->

      <v-expansion-panels v-model="panel">
        <!-- ************************
        *********************
        map and its controls ************************-->
        <v-expansion-panel @change="map_panel_change" ref="map_panel">
          <v-expansion-panel-header class="grey lighten-4">
            Map and Region(s)
          </v-expansion-panel-header>
          <v-expansion-panel-content class="">
            <hr class="mb-2" />
            <v-container fluid class="cmpbk black--text" id="home-container">
              <v-row style="height: ; min-height: 60px" class="mb-2">
                <v-col cols="12" md="12">
                  <v-card>
                    <v-card-text>
                      Draw Regions or Load Regions onto the map. Save regions if
                      they are new for re-use. Select criteris and submit a
                      search for incidents. Search terms will be matched against
                      the narrtive but the narrtive cannot be shown.
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row style="height: 60vh" class="mb-2">
                <v-col cols="12" md="12">
                  <div id="map-canvas"></div>
                  <hr />
                </v-col>
              </v-row>
              <!-- ************ DOWNLOAD ***************-->
              <v-row style="height: 15vh" class="mb-8">
                <v-col cols="12" md="12">
                  <v-card elevation="2">
                    <v-card-title dense class="pa-1">
                      Download Regions
                    </v-card-title>
                    <v-form
                      ref="fileform"
                      method="post"
                      accept-charset="utf-8"
                      id="map_form"
                    >
                      <!-- <v-input
                                  type="text"

                                >

                                </v-input> -->
                      <!-- <v-text-field
                                  dense
                                  v-show="false"
                                  class="px-1"
                                  ref="vertices"
                                  name="vertices"
                                  label="Poly Data"
                                  single-line
                                  :rules="[reqRule]"
                                  value=""
                                  placeholder=" "
                                  v-model="vertices_value"
                                >
                                </v-text-field> -->
                      <v-text-field
                        class="px-1"
                        ref="filename"
                        name="filename"
                        label="Filename"
                        single-line
                        value=""
                        placeholder="Somthing.txt"
                        required
                        :rules="[reqRule, nameRules]"
                        v-model="filename"
                      >
                      </v-text-field>
                      <v-card-actions>
                        <v-btn
                          elevation="2"
                          color="secondary"
                          class="white--text pa-md-4 mx-lg-auto"
                          @click.prevent="save_file2"
                        >
                          Save File
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                      <!-- <input

                                  type="button"
                                  name="save"
                                  value="Save!"
                                  id="save"
                                /> -->
                    </v-form>
                  </v-card>
                </v-col>
              </v-row>
              <!-- ************ UPLOAD ***************-->
              <v-row style="height: 15vh" class="mt-2">
                <v-col cols="12" md="12">
                  <v-card elevation="2">
                    <v-card-title dense class="pa-1">
                      Upload Regions
                    </v-card-title>
                    <v-form
                      ref="fileform"
                      method="post"
                      accept-charset="utf-8"
                      id="upload_form"
                    >
                      <v-file-input
                        ref="inputfile"
                        id="inputfile"
                        accept="*.txt"
                        label="File input"
                      ></v-file-input>
                    </v-form>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            @click.prevent="expansion_request_click"
            class="grey lighten-4"
          >
            Request and Processing
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <hr class="mb-2" />
            <request_form
              @process_results="process_results"
              :poly_count="polys.length"
              :request_update_dummy="request_update_dummy"
            ></request_form>
            <!-- <results_table
              v-show="results_rows.length > 0"
              :results_rows="results_rows"
              :out_of="results_rows_nomap.length"
            ></results_table> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header> Results Table </v-expansion-panel-header>

          <v-expansion-panel-content>
            <hr class="mb-2" />

            <results_table
              v-show="results_rows.length > 0"
              :results_rows="results_rows"
              :out_of="results_rows_nomap.length"
            ></results_table>
            <p v-show="results_rows.length == 0">
              No results loaded. Send a request or Load a Request or Process
              Results to see data here.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </Transition>
  </v-main>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

#map-canvas {
  width: 100%;
  height: 100%;
}
#home-container {
  max-width: 1600px;
  height: auto;
}

.casual_btn {
  width: 115px;
}

#main.v-main {
  max-width: 1600px !important;
  height: auto;
}
.v-main {
  max-width: 1600px !important;
  height: auto;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
const request_form = () => import("./request_form.vue");
const results_table = () => import("./results_table.vue");

export default {
  name: "Home",
  mixins: [bus_common],
  components: { auth, request_form, results_table },
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      request_update_dummy: 0,
      map_markers: [],
      results_rows_nomap: [],
      results_rows: [],
      panel: 0,
      map: null, // Global declaration of the map
      iw: null,
      lat_longs: [],
      markers: [],
      drawingManager: null,
      myArrPolyCoords: [],
      myStr: "",
      vertices_value: "",
      filename: "",
      polys: [], // array of polys from the map added to as they area drwan
      polysout: [], // an array of polys formated as simple objects for saving to file
      reqRule: (v) => !!v || "Field is required",
      nameRules: (v) =>
        v.length <= 60 || "Field must be less than 60 characters",
      jsonFileObj: {},
    };
  },
  watch: {
    "$store.state.user": function () {
      let self = this;
      this.init();
    },
  },
  methods: {
    message1() {
      //alert("This button does nothing yet.");
    },
    expansion_request_click() {
      this.request_update_dummy++;
    },
    clear_results_table() {
      this.results_rows = [];
      this.results_rows_nomap = [];
    },
    clear_map_makers() {
      for (let index = 0; index < this.map_markers.length; index++) {
        const marker = this.map_markers[index];
        marker.setMap(null);
      }
      this.map_markers = [];
    },
    process_results(encrypted_resultsId_requestID) {
      if (this.polys.length < 1) {
        this.swall_it(
          "Process Status",
          "Please load or draw map region(s) before processing results.",
          "success",
          null,
          null
        );
        return;
      }
      let self = this;
      this.clear_results_table();
      this.show_loader(true);
      //step one decrypt and download results
      this.decrypt_rows4request(encrypted_resultsId_requestID, function () {
        self.map_filter(self);
      });
    },
    map_filter(self) {
      //console.log("map_filter Start");

      //let self = this;
      this.clear_map_makers();
      for (
        let nomap_index = 0;
        nomap_index < this.results_rows_nomap.length;
        nomap_index++
      ) {
        const result_row_nopam = this.results_rows_nomap[nomap_index];
        // filter add to results row results_rows
        for (let poly_index = 0; poly_index < this.polys.length; poly_index++) {
          let poly = this.polys[poly_index];
          let ifin = poly.containsLatLng(
            result_row_nopam.lat,
            result_row_nopam.lon
          );
          // console.log(ifin);
          if (ifin) {
            self.results_rows.push(result_row_nopam);
          }
        }
      }
      for (let mindex = 0; mindex < self.results_rows.length; mindex++) {
        const one_result = self.results_rows[mindex];
        // public decimal lat { get; set; }
        //       public decimal lon { get; set; }

        var myLatLng = { lat: one_result.lat, lng: one_result.lon };
        var marker = new google.maps.Marker({
          position: myLatLng,
          title: one_result.clean_address,
        });

        this.map_markers.push(marker);

        // To add the marker to the map, call setMap();
        this.map_markers[this.map_markers.length - 1].setMap(this.map);

        this.map_markers[this.map_markers.length - 1].addListener(
          "click",
          function () {
            // self.iw.open(
            //   self.map,
            //   self.map_markers[self.map_markers.length - 1].title
            // );
            alert(self.map_markers[self.map_markers.length - 1].title);
          }
        );
      }
      this.show_loader(false);
      this.swall_it(
        "Process Status",
        "Mapping Results compelte.",
        "success",
        null,
        null
      );
      this.panel = 2;
    },
    decrypt_rows4request(encrypted_resultsId_requestID, callback) {
      let formIn = {};
      formIn.encrypted_resultsId_requestID = encrypted_resultsId_requestID;
      formIn.useremail = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "decrypt_rows4request";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.results_rows_nomap = this.mno(data);
          if (callback != null) {
            callback();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    map_panel_change(event) {
      if (this.$refs.map_panel.classes["v-expansion-panel--active"]) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        //this.map_initialize()
      }
    },
    upload_file() {
      var fr = new FileReader();
      let self = this;

      fr.onload = function () {
        //document.getElementById("output").textContent = fr.result;
        self.jsonFileObj = JSON.parse(fr.result);

        for (var i = 0; i < self.polys.length; i++) {
          self.polys[i].setMap(null);
        }
        self.allPolys = [];
        self.polys = [];

        let allPolys = self.jsonFileObj.allPolys;

        for (var i = 0; i < allPolys.length; i++) {
          //each item is a
          console.log(allPolys[i].poly);
          const newCoords = [];
          for (let p = 0; p < allPolys[i].poly.length; p++) {
            const coord = allPolys[i].poly[p];
            newCoords.push(allPolys[i].poly[p]);
          }

          const newPoly = new google.maps.Polygon({
            paths: newCoords,
            strokeColor: "#000000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#000000",
            fillOpacity: 0.35,
          });
          self.polys.push(newPoly);
          newPoly.setMap(self.map);
        }
      };

      fr.readAsText(document.getElementById("inputfile").files[0]);
      //  fr.readAsText(this.$refs.inputfile.files[0]);
    },
    save_file2() {
      //filename must be in for,
      var valid = this.$refs.fileform.validate();
      if (valid) {
        if (this.filename.slice(-4) != ".txt") {
          this.filename += ".txt";
        }
      } else {
        //do nothing
      }
      //polygon(s) must exist
      if (this.polys.length == 0) {
        this.swall_it(
          "No Data to save",
          "Please draw polygon(s) before saving.",
          "warning"
        );
        return;
      }
      this.polysout = [];
      //for each polygon add to the all polys
      for (let i = 0; i < this.polys.length; i++) {
        const onepoly = this.polys[i];
        this.myStr = onepoly.getPath().getArray().toString();
        this.myStr = this.myStr.replaceAll("(", "{");
        this.myStr = this.myStr.replaceAll(")", "}");
        this.myStr = this.myStr.replaceAll("},", "}|");
        let arrTemp = this.myStr.split("|");
        // console.log(arrTemp);

        //for each pair of coors record in obejct style
        for (let i = 0; i < arrTemp.length; i++) {
          let coordSplit = arrTemp[i].split(",");
          let lat = parseFloat(coordSplit[0].replaceAll("{", ""));
          let lng = parseFloat(coordSplit[1].replaceAll("}", ""));
          let coord = {
            lat: lat,
            lng: lng,
          };
          this.myArrPolyCoords.push(coord);
          //console.log(this.myArrPolyCoords);
        }
        //for each array of myArrPolyCoords add poly to polys out

        this.polysout.push({ poly: this.mno(this.myArrPolyCoords) });
        this.myArrPolyCoords = [];
      }
      let gj = { allPolys: this.polysout };
      //   gj.allPolys = allPolys.filter(f => f.del = true);
      let geojsonStr = JSON.stringify(gj);

      //let formIn = {};
      //formIn.filename = this.filename;
      //formIn.geojsonStr = geojsonStr;
      //formIn.apiname = "downloadfile";

      this.download(geojsonStr, this.filename, "text/plain");

      //this.$store
      //    .dispatch("anyapi", formIn)
      //    .then((data) => {
      //        console.log(data);
      //    })
      //    .catch((msg) => {
      //        this.show_loader(false);
      //        this.swall_it("Error", msg, "error", null, null);
      //        this.close_dialog();
      //    });

      //$.get("home/DownloadFile", { geojson: geojsonStr});
      //window.open(
      //  "api/downloadfile?geojson=" + geojsonStr + "&filename=" + this.filename,
      //  "_blank"
      //);
    },
    save_file() {
      var valid = this.$refs.fileform.validate();
      if (valid) {
        if (this.filename.slice(-4) != ".txt") {
          this.filename += ".txt";
        }
      } else {
        //do nothing
      }

      this.myStr = this.vertices_value.toString();
      if (this.myStr == "" || this.myStr == null) {
        this.swall_it(
          "No Data to save",
          "Please draw polygon(s) before saving.",
          "warning"
        );
        return;
      }
      this.myStr = this.myStr.replaceAll("(", "{");
      this.myStr = this.myStr.replaceAll(")", "}");
      this.myStr = this.myStr.replaceAll("},", "}|");

      let arrTemp = this.myStr.split("|");
      //  console.log(arrTemp);
      let myArrPolyCoords = [];

      for (var i = 0; i < arrTemp.length; i++) {
        let coordSplit = arrTemp[i].split(",");
        let lng = parseFloat(coordSplit[0].replaceAll("{", ""));
        let lat = parseFloat(coordSplit[1].replaceAll("}", ""));
        let coord = {
          lat: lat,
          lng: lng,
        };
        myArrPolyCoords.push(coord);
        //console.log(myArrPolyCoords);
      }

      let gj = { allPolys: myArrPolyCoords };
      //   gj.allPolys = allPolys.filter(f => f.del = true);
      let geojsonStr = JSON.stringify(gj);

      this.download(geojsonStr, this.filename, "text/plain");

      //$.get("home/DownloadFile", { geojson: geojsonStr});
      //window.open(
      //  "api/downloadfile?geojson=" + geojsonStr + "&filename=" + this.filename,
      //  "_blank"
      //);
    },
    download(data, filename, type) {
      var file = new Blob([data], { type: type });
      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      else {
        // Others
        var a = document.createElement("a"),
          url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      }
    },
    map_initialize() {
      let myLatlng = new google.maps.LatLng(39.5238581, -119.8515168); //at: 39.5238581, lng: -119.8515168
      let myOptions = {
        zoom: 12.5,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
      };
      this.map = new google.maps.Map(
        document.getElementById("map-canvas"),
        myOptions
      );
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON],
        },
        polygonOptions: {
          editable: true,
        },
      });
      this.drawingManager.setMap(this.map);

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (event) => {
          var newShape = event.overlay;
          newShape.type = event.type;
          this.polys.push(newShape);
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (event) => {
          this.overlayClickListener(event.overlay);
          this.vertices_value = event.overlay.getPath().getArray();
        }
      );
    },
    overlayClickListener(overlay) {
      google.maps.event.addListener(overlay, "mouseup", (event) => {});
    },
    close_dialog() {
      this.mod_state = "";
      this.dialog = false;
    },
    open_dialog() {
      this.mod_state = "ADD";
      this.new_emp = this.mno(this.blank_emp);
      this.dialog = true;
    },
    filter_nodate(value) {
      if (value === "1/1/1900") {
        return "No Date";
      } else {
        return value;
      }
    },
    toggle_item(item) {
      item.done = !item.done;
      if (item.done) {
        item.date = this.$moment().format("MM/DD/yyyy");
      } else {
        item.date = "1/1/1900";
      }
    },
    init(self) {
      document
        .getElementById("inputfile")
        .addEventListener("change", this.upload_file);
      document
        .getElementById("inputfile")
        .addEventListener("click", function () {
          self.clear_map_makers();
        });

      this.show_loader(false);
      this.iw = new google.maps.InfoWindow(); // Global declaration of the infowindow
      this.map_initialize();
      //var self = this;
      //window.setInterval(function () {
      //    console.log("log");
      //    self.show_loader(true);
      //}, 3000)
    },
  },
  mounted() {
    let polyetx = document.createElement("script");
    polyetx.setAttribute("src", "./js/maps.google.polygon.containsLatLng.js");
    document.head.appendChild(polyetx);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
